<!-- src/components/DriverLicenseSelector.vue -->

<template>
  <el-select v-model="selectedValues" :multiple="multiple" collapse-tags placeholder="请选择准驾类型" @change="handleSelectionChange">
    <el-option v-for="item in driverLicenseTypes" :key="item.value" :label="item.label" :value="item.value"></el-option>
  </el-select>
</template>
  
  <script>
import { DRIVER_LICENSE_TYPES } from './index.js'

export default {
  name: 'DriverLicenseSelector',
  props: {
    value: {
      type: [String, Array],
      default: ''
    },
    multiple: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      driverLicenseTypes: DRIVER_LICENSE_TYPES,
      selectedValues: this.value
    }
  },
  watch: {
    value(newVal) {
      this.selectedValues = newVal
    }
  },
  methods: {
    handleSelectionChange(val) {
      this.$emit('input', val)
    }
  }
}
</script>
  
  <style scoped>
</style>